import axiosInstance from "../services/axiosInstance";

export const isDraftBookingStatus = (status) => status === "draft";

export const shouldAbandonDraft = (_bookingType, currentStatus, options = {}) => {
  if (options.hasForeignPartnerClient) return false;
  return isDraftBookingStatus(currentStatus);
};

export const abandonDraftBooking = async (bookingUuid) => {
  if (!bookingUuid) return;
  await axiosInstance.delete(`/bookings/${bookingUuid}`);
};

export const abandonDraftBookingKeepalive = (bookingUuid) => {
  if (!bookingUuid) return;

  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const currencyCode = localStorage.getItem("currencyCode") || "eu";

  fetch(`${baseURL}/bookings/${bookingUuid}`, {
    method: "DELETE",
    credentials: "include",
    keepalive: true,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Key-Inflection": "camel",
      Currency: currencyCode,
    },
  });
};
